import React, { ReactElement, useCallback } from "react";
import { connect, FormikContextType } from "formik";
import { InkomenEnFiscusState } from "../infra/inkomen-en-fiscus-schema";
import { getInkomenEnFiscusTextResources } from "../infra/inkomen-en-fiscus-resources";
import FiscaleBijtelpostenModal from "../fiscale-bijtelposten-modal/fiscale-bijtelposten-modal";
import FiscaleAftrekpostenModal from "../fiscale-aftrekposten-modal/fiscale-aftrekposten-modal";
import { bindSaveFunction } from "../../shared/utils/bind-save-function";
import { CurrencyInput, LabeledCurrencyInput, LabeledToggleInput, Icon, LabeledBevestigingInput, ModalButton, SyncHeightProps, SyncHeight } from "adviesbox-shared";

const Aanvrager1Fiscaliteit = ({
  formik: {
    setFieldValue,
    values: { aanvrager1Fiscaliteit, aanvrager1Inkomen }
  },
  targetRef: syncHeightRef,
  sourceRef: assignRef
}: SyncHeightProps & {
  formik: FormikContextType<InkomenEnFiscusState>;
}): ReactElement => {
  const createSaveFunction = useCallback(bindSaveFunction(setFieldValue), [setFieldValue]);
  const hasOnderneming = aanvrager1Inkomen.ondernemingIsEnabled;
  return (
    <SyncHeight targetRef={syncHeightRef} sourceRef={assignRef}>
      <LabeledToggleInput
        caption="Fiscale aftrekposten"
        name="aanvrager1Fiscaliteit.toggleFiscaleAftrekposten"
        appendChildren={
          <CurrencyInput
            name="aanvrager1Fiscaliteit.fiscaleAftrekposten.teBetalenAlimentatie"
            readonly={true}
            placeholder="-"
            appendChildren={
              <ModalButton
                resetSize={true}
                parent="aanvrager1Fiscaliteit.fiscaleAftrekposten"
                content={<Icon name="specificatie" alt="Fiscale aftrekposten" />}
              >
                <FiscaleAftrekpostenModal
                  data={aanvrager1Fiscaliteit.fiscaleAftrekposten}
                  onSave={createSaveFunction("aanvrager1Fiscaliteit.fiscaleAftrekposten")}
                />
              </ModalButton>
            }
          />
        }
      />

      <LabeledToggleInput
        caption="Fiscale bijtelposten"
        name="aanvrager1Fiscaliteit.toggleFiscaleBijtelposten"
        appendChildren={
          <CurrencyInput
            name="aanvrager1Fiscaliteit.fiscaleBijtelposten.bijtellingOpInkomen"
            readonly={true}
            placeholder="-"
            appendChildren={
              <ModalButton
                resetSize={true}
                parent="aanvrager1Fiscaliteit.fiscaleBijtelposten"
                content={<Icon name="specificatie" alt="Fiscale bijtelposten" />}
              >
                <FiscaleBijtelpostenModal
                  data={aanvrager1Fiscaliteit.fiscaleBijtelposten}
                  onSave={createSaveFunction("aanvrager1Fiscaliteit.fiscaleBijtelposten")}
                />
              </ModalButton>
            }
          />
        }
      />
      <LabeledCurrencyInput
        allowNull={false}
        caption="Beleggingskorting"
        name="aanvrager1Fiscaliteit.beleggingskorting"
        tooltip={getInkomenEnFiscusTextResources("TooltipFiscaliteitBeleggingsKorting")}
      />
      {hasOnderneming && (
        <>
          <h3 className="pt-3 pl-3">Ondernemersfaciliteiten</h3>
          <LabeledBevestigingInput caption="Zelfstandigenaftrek" name="aanvrager1Fiscaliteit.zelfstandigenaftrek" />
          <LabeledBevestigingInput caption="Meewerkaftrek" name="aanvrager1Fiscaliteit.meewerkaftrek" />
          <LabeledBevestigingInput caption="Mkb winstvrijstelling" name="aanvrager1Fiscaliteit.mkbWinstvrijstelling" />
        </>
      )}
    </SyncHeight>
  );
};

export default connect<SyncHeightProps, InkomenEnFiscusState>(Aanvrager1Fiscaliteit);
